import { ErrorModal, HelmetDexteel } from "@dexteel/mesf-core";
import { CircularProgress, Grid2 as Grid } from "@mui/material";
import Paper from "@mui/material/Paper";
import { useEffect, useState } from "react";
import { getCatalogLostStrandTypes } from "../../repositories/ProductionRepository";
import { useCatalogLostStrandTypesContext } from "./CatalogLostStrandTypesContext";
import { TableLostStrandTypes } from "./components/TableLostStrandTypes";

type Props = {};
export const CatalogLostStrandTypesPage = (props: Props) => {
	const { state, actions } = useCatalogLostStrandTypesContext();
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState("");

	const getLostStrandTypesFromAPI = async () => {
		setIsLoading(true);
		const resp = await getCatalogLostStrandTypes();
		if (resp.ok) {
			actions.setLostStrandTypes(resp.data.tables[0].rows);
			setIsLoading(false);
		} else {
			setError(resp.message);
		}
	};

	useEffect(() => {
		getLostStrandTypesFromAPI();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	if (state.lostStrandTypes) {
		return (
			<>
				<HelmetDexteel title="Lost Strand Types - Configurations" />
				<Grid container justifyContent="center" alignItems="center">
					<Grid size={{ xs: 12, md: 12 }} style={{ margin: 0 }}>
						<Paper
							elevation={0}
							style={{
								width: "100%",
								padding: "15px 20px 10px",
								borderRadius: "0.75rem",
							}}
						>
							<TableLostStrandTypes
								isLoading={isLoading}
								getLostStrandTypesFromAPI={getLostStrandTypesFromAPI}
							/>
						</Paper>
					</Grid>
				</Grid>
				<ErrorModal error={error} onHide={() => setError("")} />
			</>
		);
	}
	return (
		<Grid
			size={{ xs: 12 }}
			style={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: "70vh",
			}}
		>
			<CircularProgress />
		</Grid>
	);
};
